<template>
  <div>
    <!--/pricing -->
    <section class="pricing bg-light py-5" id="pricing">
      <div class="container py-lg-3">
        <div class="inner-sec">
          <h3 class="heading mb-5 text-center" data-aos="zoom-in">
            Nos formations
          </h3>
          <div class="price-right">
            <div class="tabs">
              <ul
                class="nav nav-pills my-md-5 my-3 justify-content-center"
                id="pills-tab"
                role="tablist"
              ></ul>
              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div class="menu-grids">
                    <div class="row t-in">
                      <div
                        class="col-lg-3 col-sm-6 price-main-info"
                        data-aos="zoom-in-up"
                      >
                        <div class="price-inner card box-shadow p-4">
                          <div class="card-body">
                            <h4 class="">Site web</h4>
                            <h5 class="card-title pricing-card-title">
                              <span class="">EUR</span> 150 <span> 1 mois</span>
                            </h5>
                            <ul class="list-unstyled mt-3 mb-4">
                              <li>HTML 5</li>
                              <li>CSS 3</li>
                              <li>Vs Code</li>
                              <li>FileZilla</li>
                            </ul>
                            <div class="log-in mt-md-3 mt-2">
                              <a class="btn scroll" @click="envoyer('Je vous écris pour exprimer mon intérêt à participer à la formation de création de site web que votre organisation propose. Ayant pris connaissance du programme de la formation et des compétences qu\'elle offre, je suis convaincu(e) que cette opportunité correspond parfaitement à mes objectifs personnels et professionnels.')"
                              href="#contact">S'inscrire</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 col-sm-6 mt-md-0 mt-5 price-main-info"
                        data-aos="zoom-in-up"
                      >
                        <div class="price-inner card box-shadow p-4">
                          <div class="card-body">
                            <h4 class="">Java</h4>
                            <h5 class="card-title pricing-card-title">
                              <span class="">EUR</span> 460 <span> 1 mois</span>
                            </h5>
                            <ul class="list-unstyled mt-3 mb-4">
                              <li>Jdk >= 11</li>
                              <li>POO Java</li>
                              <li>FrameWorks</li>
                              <li>API RESTful</li>
                            </ul>
                            <div class="log-in mt-md-3 mt-2">
                              <a class="btn scroll"
                              @click="enenvoyant('Je vous écris pour exprimer mon intérêt à participer à la formation en Java que votre organisation propose. Ayant pris connaissance du programme de la formation et des compétences qu\'elle offre, je suis convaincu(e) que cette opportunité correspond parfaitement à mes objectifs personnels et professionnels.')"
                              href="#contact">S'inscrire</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 col-sm-6 mt-lg-0 mt-5 price-main-info"
                        data-aos="zoom-in-up"
                      >
                        <div class="price-inner card box-shadow p-4">
                          <div class="card-body">
                            <h4 class="">Bureautique</h4>
                            <h5 class="card-title pricing-card-title">
                              <span class="">EUR</span> 125 <span> 1 mois</span>
                            </h5>
                            <ul class="list-unstyled mt-3 mb-4">
                              <li>Généralité</li>
                              <li>Word avancé</li>
                              <li>Excel avancé</li>
                              <li>PowerPoint</li>
                            </ul>
                            <div class="log-in mt-md-3 mt-2">
                              <a class="btn scroll" 
                              @click="enenvoyant('Je vous écris pour exprimer mon intérêt à participer à la formation en Bureautique que votre organisation propose. Ayant pris connaissance du programme de la formation et des compétences qu\'elle offre, je suis convaincu(e) que cette opportunité correspond parfaitement à mes objectifs personnels et professionnels.')"
                              href="#contact">S'inscrire</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 col-sm-6 mt-lg-0 mt-5 price-main-info"
                        data-aos="zoom-in-up"
                      >
                        <div class="price-inner card box-shadow p-4">
                          <div class="card-body">
                            <h4 class="">Rédaction web</h4>
                            <h5 class="card-title pricing-card-title">
                              <span class="">EUR </span> 200
                              <span> 1 mois</span>
                            </h5>
                            <ul class="list-unstyled mt-3 mb-4">
                              <li>Une bonne base</li>
                              <li>Spécificités</li>
                              <li>Rédacteur web SEO</li>
                            </ul>
                            <div class="log-in mt-md-3 mt-2">
                              <a class="btn scroll"
                              @click="enenvoyant('Je vous écris pour exprimer mon intérêt à participer à la formation en Rédaction Web que votre organisation propose. Ayant pris connaissance du programme de la formation et des compétences qu\'elle offre, je suis convaincu(e) que cette opportunité correspond parfaitement à mes objectifs personnels et professionnels.')"
                              href="#contact">S'inscrire</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //pricing -->

    <!-- faqs -->
    <section class="faq-w3l py-5" id="faq">
      <div class="container py-lg-3">
        <h3 class="heading mb-5 text-center" data-aos="zoom-in">
          Nos Réalisations
        </h3>
        <div class="row faq-info">
          <div class="col-md-6 faq-w3agile">
            <ul class="faq pl-sm-4 pl-3">
              <li
                class="item1 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-left"
              >
                <h4>Asma - All for School Management</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      Application Web de Gestion des écoles, englobant les
                      modules d'inscription et de reinscription, de gestion des
                      des notes, de gestion des enseignants et de délivrance
                      bulletins de fin d'année.
                    </p>
                  </li>
                </ul>
              </li>

              <li
                class="item3 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-left"
              >
                <h4>Mab</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      Plateforme web de Gestion des membres de l'église
                      Adventiste au Bénin. Elle permet d'avoir une base de
                      données à jour des membres baptisés ainsi que des
                      informations de baptème, des pasteurs qui exercent et qui
                      ont eu à exercé au Bénin.
                    </p>
                  </li>
                </ul>
              </li>

              <li
                class="item5 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-right"
              >
                <h4>Asercom</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      Logiciel Desktop de gestion des Ressortissant de la
                      commune de Mono-Couffo à l'Université de Parakou. Il
                      assure une collecte et une gestion efficace des tous les
                      étudiants (anciens ou nouveaux) provenant des communes du
                      Mono et du Couffo et étudiant à l'Université de Parakou
                    </p>
                  </li>
                </ul>
              </li>
              
              
            </ul>
          </div>
          <div class="col-md-6 faq-w3agile">
            <ul class="faq pl-sm-4 pl-3">
              

              <li
                class="item2 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-left"
              >
                <h4>WebShop - Librairie</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      Application web de gestion de librairie de Safeliz au
                      Bénin. Elle prend en compte la gestion de stock, la vente
                      des livres, la gestion de la comptabilité et les tableaux
                      de bords pour les statistques
                    </p>
                  </li>
                </ul>
              </li>

              <li
                class="item6 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-right"
              >
                <h4>Webshop - Caisse</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      Est une application web qui permet aux boutiques et aux
                      centres de ventes d'assurer une bonne gestion de leur
                      stock, une bonne gestion de la vente de leur article et de
                      délivrer des factures conformes aux normes reglemenataires
                      du Bénin.
                    </p>
                  </li>
                </ul>
              </li>
              <li
                class="item7 item mt-sm-4 mt-3 pt-3 pl-2"
                data-aos="flip-right"
              >
                <h4>Gec</h4>
                <ul>
                  <li class="subitem1 mt-3">
                    <p>
                      C'est un concept innovant qui permet étape par étape de
                      réduire la redondance, sous toute sa forme, dans le
                      traitement et la circulation de l'information au sein
                      d'une votre institution.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- //faqs -->

    <!-- testimonials -->
    <!--<section class="testimonials bg-light py-5" id="testimonials">
      <div class="container py-lg-3">
        <h3 class="heading mb-5 text-center" data-aos="zoom-in">
          Honorable Clients
        </h3>
        <div class="row test-grids">
          <div class="col-md-4 col-sm-7 col-9" data-aos="zoom-in">
            <img src="images/b3.png" alt="" class="img-fluid" />
          </div>
          <div class="col-md-8">
            <div class="callbacks_container">
              <ul class="rslides" id="slider3">
                <li data-aos="fade-down">
                  <div class="testi-pos">
                    <h4>john watson</h4>
                    <span class="">- congue leo</span>
                    <ul class="d-flex mt-2">
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas fa-star"></i></li>
                    </ul>
                  </div>
                  <div class="testi-agile">
                    <p>
                      <i class="fas fa-quote-left pr-3"></i>Vivamus magna justo,
                      lacinia eget consectetur sed, convallis at tellus. Nulla
                      quis lorem ut libero malesuada feugiat.Nulla quis lorem ut
                      libero malesuada feugiat. Donec rutrum congue leo eget
                      malesuada. Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit.
                    </p>
                  </div>
                </li>
                <li data-aos="fade-down">
                  <div class="testi-pos">
                    <h4>Paul walkner</h4>
                    <span class="">- lacinia eget</span>
                    <ul class="d-flex mt-2">
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas fa-star"></i></li>
                    </ul>
                  </div>
                  <div class="testi-agile">
                    <p>
                      <i class="fas fa-quote-left pr-3"></i>Donec rutrum congue
                      leo eget consectetur sed, convallis at tellus. Nulla quis
                      lorem ut libero malesuada feugiat.Nulla quis lorem ut
                      libero malesuada feugiat. Donec rutrum congue leo eget
                      malesuada. Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit
                    </p>
                  </div>
                </li>
                <li data-aos="fade-down">
                  <div class="testi-pos">
                    <h4>Anderson</h4>
                    <span class="">- Donec rutru</span>
                    <ul class="d-flex mt-2">
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas mr-1 fa-star"></i></li>
                      <li><i class="fas fa-star"></i></li>
                    </ul>
                  </div>
                  <div class="testi-agile">
                    <p>
                      <i class="fas fa-quote-left pr-3"></i>Vivamus magna justo,
                      lacinia eget consectetur sed, convallis at tellus. Nulla
                      quis lorem ut libero malesuada feugiat.Nulla quis lorem ut
                      libero malesuada feugiat. Donec rutrum congue leo eget
                      malesuada. Lorem ipsum dolor sit amet, consectetur
                      adipiscing elit
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>-->
    <!-- //testimonials -->
  </div>
</template>

<script>
export default {
  name: "Others-Item",
  methods: {
    envoyer(texte){
      this.$emit('prendre', texte);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>